import { canWriteCookieCategory } from './categories';
const optionNamesMap = {
    category: null,
    domain: 'domain',
    expires: 'expires',
    maxAge: 'max-age',
    path: 'path',
    sameSite: 'samesite',
    secure: 'secure',
};
const formatCookieOptionName = (name) => {
    return optionNamesMap[name] || name;
};
const optionValuesMap = {
    category: null,
    domain: undefined,
    expires: (date) => new Date(date).toUTCString(),
    maxAge: undefined,
    path: undefined,
    sameSite: undefined,
    secure: (_isSecure) => undefined,
};
const formatCookieOptionValue = (name, value) => {
    if (optionValuesMap[name]) {
        return optionValuesMap[name](value);
    }
    return value;
};
const stringifyOptions = (options) => {
    return Object.entries(options)
        .filter(([name, value]) => {
        return name !== 'category' && value !== false;
    })
        .map(([name, value]) => {
        const formattedName = formatCookieOptionName(name);
        const formattedValue = formatCookieOptionValue(name, value);
        return formattedValue === undefined
            ? `; ${formattedName}`
            : `; ${formattedName}=${formattedValue}`;
    }, [])
        .join('')
        .trim();
};
export const writeCookie = (name, value, options) => {
    try {
        const encodedName = encodeURIComponent(name);
        const encodedValue = encodeURIComponent(value);
        const stringifiedOptions = stringifyOptions(options);
        if (canWriteCookieCategory(options.category)) {
            document.cookie = `${encodedName}=${encodedValue}${stringifiedOptions}`.trim();
            return true;
        }
        console.warn(`writeCookie :: Could not write cookie ${name} in unconsented category ${options.category}.`);
        return false;
    }
    catch (e) {
        console.error(`writeCookie :: Could not write cookie ${name}.`, e);
        return false;
    }
};
//# sourceMappingURL=writeCookie.js.map
// @zapier/cookies@1.1.3 (6a0d73ece)
